import { j as i } from "../../../jsx-runtime-BwWtxLpl.js";
import d from "classnames";
import r from "prop-types";
import { useContext as n, useEffect as u } from "react";
import { IconoirWarningCircle as I } from "@ey-xd/motif-icon";
import "../form-field/form-field.js";
import { FormFieldContext as x } from "../form-field/form-field.context.js";
import { MotifIcon as g } from "../../icon/icon.js";
import { IconContext as h } from "../../icon/icon.context.js";
const M = {
  error: I
}, N = (a) => {
  const { children: c, className: m = "", icons: s = {}, showIcon: l = !1, ...f } = a, o = n(x), { errorMessage: t } = n(h);
  let e;
  t ? e = {
    ...t,
    ...s
  } : e = {
    ...M,
    ...s
  }, u(() => (o.setInvalid(!0), () => {
    o.setInvalid(!1);
  }), []);
  const p = d({
    "motif-error-message": !0,
    [m]: !0
  });
  return /* @__PURE__ */ i.jsxs(
    "p",
    {
      role: "alert",
      id: o.idErrorMessage,
      ...f,
      className: p,
      "data-motif-error-message": !0,
      "aria-live": "assertive",
      children: [
        l && /* @__PURE__ */ i.jsx(g, { className: "motif-error-icon", iconFunction: e.error }),
        c
      ]
    }
  );
};
N.propTypes = {
  children: r.node,
  className: r.string,
  icons: r.shape({
    error: r.node
  }),
  showIcon: r.bool
};
export {
  N as MotifErrorMessage
};
